import React, { useEffect, useState } from 'react'
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { Link as LinkRouter, useLocation } from 'react-router-dom'
import { useTheme } from '@material-ui/core/styles'

export const TERMS_URL = '/terms'
export const PRIVACY_URL = '/privacy'
export const DISCLAIMER_URL = '/disclaimer'

export default function Footer(): JSX.Element {
  const location = useLocation()
  const [activePage, setActivePage] = useState<string>('')
  const theme = useTheme()
  const matchesSM: boolean = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    setActivePage(location.pathname)
  }, [location.pathname])

  return (
    <Box sx={{ p: matchesSM ? 2 : 6 }} component="footer">
      <Breadcrumbs
        aria-label="breadcrumb"
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Link
          color={TERMS_URL === activePage ? 'primary' : 'inherit'}
          component={LinkRouter}
          to={TERMS_URL}
        >
          <Typography variant="caption" display="block">
            Terms
          </Typography>
        </Link>
        <Link
          color={PRIVACY_URL === activePage ? 'primary' : 'inherit'}
          component={LinkRouter}
          to={PRIVACY_URL}
        >
          <Typography variant="caption" display="block">
            Privacy
          </Typography>
        </Link>
        <Link
          color={DISCLAIMER_URL === activePage ? 'primary' : 'inherit'}
          component={LinkRouter}
          to={DISCLAIMER_URL}
        >
          <Typography variant="caption" display="block">
            Disclaimer and Legal Notices
          </Typography>
        </Link>
      </Breadcrumbs>
      <Typography variant="body2" color="textSecondary" align="center">
        {`Copyright © Todobe ${new Date().getFullYear()}.`}
      </Typography>
    </Box>
  )
}
